import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { Client, getClient } from '../../contentful/getClients';
import { QueryKeys } from '../../domain/QueryKeys';

export const useClients = (): UseQueryResult<Client[]> => {
    return useQuery({
        queryKey: [QueryKeys.useClients],
        queryFn: async () => {
            const clientData = await getClient();
            return clientData;
        },
        enabled: true,
        staleTime: 5 * 60 * 60,
    });
};
